/* Keep the actual Kaching widget at the editable purchase slot. Its emitted
 * selling-plan choice also drives the native theme's AJAX purchase controller. */
(()=>{
 const init=()=>{
  const root=document.querySelector('[id$="__eye_main"] icp-product');
  if(!root?.ready||root.dataset.eyeInitialized)return;
  root.dataset.eyeInitialized='true';
  const originalSelection=root.selection.bind(root);
  root.eyeSellingPlanId=null;
  root.selection=()=>{
   const state=originalSelection();
   const allocation=state.variant?.allocations.find(a=>String(a.id)===String(root.eyeSellingPlanId));
   return {...state,subscribed:!!allocation,allocation,price:allocation?allocation.price:state.variant?.price};
  };
  root.dataset.eyeKachingBridge='true';
  if(!new URL(location.href).searchParams.has('variant')){
   const input=root.querySelectorAll('.icp-option--bundle input')[1];
   if(input){input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));}
  }
  const place=()=>{
   const slot=root.querySelector('[data-eye-subscription-slot]');
   const host=document.querySelector('kaching-subscriptions[product-id="'+root.dataset.productId+'"]');
   if(slot&&host&&!slot.contains(host))slot.append(host);
  };
  place();
  const observer=new MutationObserver(()=>{if(root.isConnected)place();else observer.disconnect();});
  observer.observe(document.body,{childList:true,subtree:true});
 };
 document.addEventListener('kaching-subscriptions:selling-plan-change',event=>{
  const root=document.querySelector('[id$="__eye_main"] icp-product');
  if(!root?.ready||root.dataset.eyeKachingBridge!=='true')return;
  const host=event.target.closest('kaching-subscriptions');
  if(!host||host.getAttribute('product-id')!==root.dataset.productId)return;
  const next=event.detail?.sellingPlanId||null;
  if(next===root.eyeSellingPlanId)return;
  root.eyeSellingPlanId=next;
  root.sync(false);
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
